import { Box, CircularProgress } from '@mui/material'

const Loader = ({ size = 60 }) => {
  return (
    <Box display="flex" alignItems="center" justifyContent="center" width="100%">
      <CircularProgress size={size} />
    </Box>
  )
}

export default Loader
